import actions from './actions';
import getters from './getters';
import mutations from './mutations';

const state = {
  recepciones: [],
  contenedores: [],
  rutas: [],
  // New state for invoice persistence
  selectedInvoice: null,
  receiptType: 'FACTURAS',
};

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations,
};